import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput, NumberInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <NumberInput source="foreignId" label={'foreignId'}/>
        </CreateGuesser>
    )
}

export default Create
